import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';
import { useAuth, useToken } from '@cabukaka/hooks';
import { User } from '@cabukaka/types';
import Loader from '../../components/ui/Loader';

type UserRole = User['role']
type ProtectedRouteProps = {
  children: ReactNode;
  allowedRoles: UserRole[];
  requireAbonnement?: boolean; // ➕ optionnel : true si la page demande un abo actif
};

export default function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const {token} = useToken()
  const location = useLocation();

  if (loading) return <Loader />;

  if (!user) {
     return <Navigate to={`/redirect?token=${token}`} state={{ from: location }} replace />;
  }

    const userRole  = user.role;


  // 🔒 Vérif rôle
  if (userRole && !allowedRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  }


  return <>{children}</>;
}
